import { ExternalContainer } from "../../components/Account/reusables";
import CartItems from "./CartItems";
import Checkout from "./Checkout";

const Cart = () => {
  return (
    <div className="h-full w-[full] lg:px-[50px] xl:px-[56px]">
      <ExternalContainer>
        <div className="flex flex-col lg:flex-row gap-16 items-center bp:p-20">
          <CartItems />
          <Checkout />
        </div>
      </ExternalContainer>
    </div>
  );
};

export default Cart;
